import { uuid } from "@odm/utils/utils";

const allUsers = [
  {
    id: uuid(),
    userName: "e2009@isdb.onmicrosoft.com",
    displayName: "Anastasios Georgousakis",
    emailAddress: "anastasios.georgousakis@noema.net",
  },
  {
    id: uuid(),
    userName: "e2066@isdb.onmicrosoft.com",
    displayName: "Jean-Paul Davoutian",
    emailAddress: "jeanpaul.davoutian@noema.net",
  },
];

export default allUsers;
